import { render, staticRenderFns } from "./ReservationProcessDataTransitionDistributionPayment.vue?vue&type=template&id=cc71ba5e&scoped=true&"
import script from "./ReservationProcessDataTransitionDistributionPayment.vue?vue&type=script&lang=js&"
export * from "./ReservationProcessDataTransitionDistributionPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc71ba5e",
  null
  
)

export default component.exports